module.exports = __webpack_public_path__ + "media/images/icon_search_btn_gray-fc3da9e56896614e5018aadc33340423.png";